export default __webpack_public_path__ + "static/media/TestimonialProfile.421b8b46.svg";